import { Injectable } from '@angular/core';


export class CardService {
  
  private cards: any[] = []; // Arreglo privado para almacenar las tarjetas
  isSelected: boolean[] = [];
  selectedIndex: number;
  isAgendaAdded: boolean;

  constructor() { }

  setCards(list: any){
    this.cards = list;
  }

  getCards() {
    return this.cards;
  }

  getLength(){
    return this.cards.length;
  }

  addCard(obj: any) {
    this.cards.push(obj);
    this.isSelected.push(false); // Agregar un nuevo estado para la nueva tarjeta
  }

  deleteCard(obj: any) {
    let pos: number = -1;
    this.cards.find((elem, index) => {
      if (elem === obj) {
        pos = index;
      }
    });

    console.log('Eliminando tarjeta en índice:');
    this.selectedIndex = pos;

    this.cards.splice(pos, 1);
    this.isSelected.splice(pos, 1); // Eliminar el estado correspondiente a la tarjeta eliminada
    console.log('Tarjeta eliminada:', this.cards);
  }

  
}
